export default __webpack_public_path__ + "static/media/html-emails-banner.e63e74ca.svg";